/**
 * 牌面圖片 URL 解析 + 載入失敗 fallback。
 *
 * R2 公開 URL 從 VITE_R2_PUBLIC_URL env 取得，dev 時可不設定（會落到 placeholder 漸層）。
 */

import type { Theme } from './personas';

const DEFAULT_R2_PUBLIC_URL = 'https://pub-731875d053bf409587ef6e0a9da4847a.r2.dev';
const R2_PUBLIC_URL = (import.meta.env.VITE_R2_PUBLIC_URL ?? DEFAULT_R2_PUBLIC_URL).replace(/\/$/, '');

export function cardImageUrl(slug: string, theme: Theme): string | null {
  if (!R2_PUBLIC_URL) return null;
  return `${R2_PUBLIC_URL}/cards/${theme}/${slug}.png`;
}

/** 把 slug 顯示成可讀標題：'the-fool' → 'The Fool'。 */
export function slugToTitle(slug: string): string {
  return slug
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** Placeholder 漸層（牌背 / 載入失敗時顯示）。 */
export const CARD_BACK_GRADIENT =
  'linear-gradient(135deg,#1a1530 0%,#3a2858 40%,#6e58a8 80%,#d4af37 100%)';
